import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  ControlLabel
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'
import {
  ToggleModal
} from 'components/Modal'
import { Menu, MenuItem } from 'components/Menu'
import {
  MenuItem as SidebarMenuItem
} from 'components/Sidebar'
import Scrollbars from 'components/Scrollbars'
import AddExistingLayout from './AddExistingLayout'
import AddLayoutModal from './AddLayoutModal'
import AddNewLayout from '../../AddNewLayout'
import classes from './AddLayout.module.scss'

const ModalActionTypes = {
  ADD_EXISTING_LAYOUT: 'ADD_EXISTING_LAYOUT',
  ADD_NEW_LAYOUT: 'ADD_NEW_LAYOUT',
}

export class AddLayout extends React.Component {
  state = {
    modalAction: false
  }

  handleAddLayoutModalToggle = (modalAction) => {
    this.setState({
      modalAction
    })

    if (this.props.onToggle) {
      this.props.onToggle(Boolean(modalAction))
    } 
  }

  handleAddExistingLayoutClick = () => {
    this.setState({
      modalAction: ModalActionTypes.ADD_EXISTING_LAYOUT
    })
  }

  handleAddNewLayoutClick = () => {
    this.setState({
      modalAction: ModalActionTypes.ADD_NEW_LAYOUT
    })
  }

  closeModal = () => {
    this.setState({
      modalAction: false
    })
  }

  renderModal = () => {
    const {
      modalAction
    } = this.state

    if (!modalAction) return null

    if (modalAction === true) {
      return (
        <Menu>
          <MenuItem
            onClick={this.handleAddNewLayoutClick}
          >
            <FormattedMessage
              id='DESK_ADD_NEW'
            />
          </MenuItem>
          <MenuItem
            onClick={this.handleAddExistingLayoutClick}
          >
            <FormattedMessage
              id='DESK_ADD_EXISTING'
            />
          </MenuItem>
        </Menu>
      )
    }

    if (modalAction === ModalActionTypes.ADD_EXISTING_LAYOUT) {
      return <AddExistingLayout />
    }

    if (modalAction === ModalActionTypes.ADD_NEW_LAYOUT) {
      return (
        <AddLayoutModal>
          <ControlLabel className={classes.addNewLayoutHeader}>
            <FormattedMessage id='DESK_ADD_NEW' />
          </ControlLabel>
          <Scrollbars className='p-10'>
            <AddNewLayout
              addToMyHomeLayout
              close={this.closeModal}
            />
          </Scrollbars>
        </AddLayoutModal>
      )
    }
  }

  render () {
    const {
      modalAction
    } = this.state

    return (
      <ToggleModal
        backdrop
        show={Boolean(modalAction)}
        onToggle={this.handleAddLayoutModalToggle}
        attachment='top center'
        targetAttachment='top center'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        <SidebarMenuItem
          className={classes.addLayout}
          title={
            <div className={classes.addLayoutTitle}>
              <KanBoIcon
                name='kanbo-16-plus'
                style={{ marginRight: '0.5em' }}
              />
              <FormattedMessage id='DESK_ADD' />
            </div>
          }
        />
        {this.renderModal()}
      </ToggleModal>
    )
  }
}

export default AddLayout
